import { colors, typography } from "./foundations";

import {
  Accordion,
  Anchor,
  Button,
  Card,
  Checkbox,
  Divider,
  Dropdown,
  FormLabel,
  Heading,
  Input,
  List,
  NumberInput,
  PinInput,
  Radio,
  Select,
  Text,
  Textarea,
} from "./components";

export const theme = {
  colors,
  ...typography,
  shadows: {
    outline: "0 0 0 3px hsla(354, 81%, 42%, .5)",
  },
  components: {
    Accordion,
    Anchor,
    Button,
    Card,
    Checkbox,
    Divider,
    Menu: Dropdown,
    FormLabel,
    Heading,
    Input,
    List,
    NumberInput,
    PinInput,
    Radio,
    Select,
    Text,
    Textarea,
  },
};
